import { render, staticRenderFns } from "./Footer2.vue?vue&type=template&id=c94bf318&scoped=true&"
import script from "./Footer2.vue?vue&type=script&lang=js&"
export * from "./Footer2.vue?vue&type=script&lang=js&"
import style0 from "./Footer2.vue?vue&type=style&index=0&id=c94bf318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94bf318",
  null
  
)

export default component.exports